export const MAXIMUM_FRACTION_DIGITS = 2
